import PurchasePriceFilters from './PurchasePriceFilters';

export default PurchasePriceFilters;
